/**
 * ServerLoginService communicates with a Mutara Server instance and 
 * exchanges the necessary information to establish and maintain an 
 * HttpClient connection using the XSRF standards.
 */

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse, HttpEvent, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, ObservableInput } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContextService, ServerServiceConfig, LayoutInterface, LoginData } from './context.service';
import { NavigationStart, Router } from '@angular/router';
import { v5 as uuidv5 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class ServerLoginService implements HttpInterceptor {
  private token: string | null = null;
  private adminToken: string | null = null;
  private logoutTime: number = 0;
  private isLoad: boolean = false;
  static securityToken: string | null = null;
  static myIp: any;
  static logoutTimer: number = -1;
  static configService: ServerServiceConfig;

  constructor(
    public http: HttpClient,
    private router: Router,
    private context: ContextService) {
    // Reload stored token
    // context.subscribeTo("layoutIdentity", (layout: LayoutInterface) => {
    //   if (!this.token || this.token.startsWith('{')) {
    //     this.setToken(this.getSecureToken(), layout);
    //   }
    // });
    this.context.unsetLoginData();
    
    context.subscribeTo("loginData", (loginData: LoginData) => {
      try {
        //sessionStorage.setItem('login', JSON.stringify(loginData ?? {}))
      } catch (err) {
        console.error("Can't set local storage %O %O", loginData, err);
      }
    });
    context.subscribeTo("logout", (clearSession: boolean) => {
      if (clearSession) {
        this.context.showProgress(false);
        if (!!ServerLoginService?.configService?.serviceUrl) {
          if (!this.isLoad) {
            this.http.post('$service/logout', {}).subscribe({
              error: (error: HttpErrorResponse) => {
                console.error('Logout error %O', error);
                this.context.__clearSession();
                this.router.navigate(['/apply']);
              },
              next: (data: any) => {
                console.log('Logout success data %O', data);
                this.context.__clearSession();
                // this.setToken(null);
                this.router.navigate(['/apply'], { replaceUrl: true });
              }
            });
          }
        }
      }
    });
   
    router.events.subscribe({
      next: (value) => {
        if (value instanceof NavigationStart) {
          const data: any = this.router.currentNavigation()?.extras?.state;
          try {
            // const loginData = data?.login ?? JSON.parse(sessionStorage.getItem('login') ?? '{}')
            // if (loginData.username) {
            //   this.context.nextMessage('loginData', loginData);
            //   // } else {
            //   //   this.context.nextMessage('logout', true);
            // }
          } catch (err) {
            console.error('Router error %O', err);
            this.context.nextMessage('logout', true);
          }
        }
      }
    });
  }

  /**
   * This is where we inject the configuration at start time
   */
  load(): (() => Promise<boolean>) {
    return (): Promise<boolean> => {
      return new Promise<boolean>(async (resolve: (a: boolean) => void): Promise<void> => {
        /*      // Here we can pull the config url from the .json file so we can connect to chat
              import('ngx-socket-io').then((module) => {
                console.log("Socket.io available, bootstrap configuration...");
        */
        this.isLoad = true;
        this.http.get('https://api.ipify.org?format=json').subscribe({
          error: (err) => console.error('Client IP Error %O', err),
          next: (result: any) => {
            this.context.setClientIp(result.ip); ServerLoginService.myIp = result;
            this.http.get<any>('/config').subscribe({
              error: (httpError: HttpErrorResponse) => {
                console.error('Config load error %O', httpError);
              },
              next: (result: any) => {
                let config: any = result;
                // Received the response we want, set the data locally for use, ensure chat is set to use the data
                if (!config.serviceUrl) {
                  config.serviceUrl = config['default-serviceUrl']; // DEFAULT
                }
                ServerLoginService.securityToken = uuidv5((ServerLoginService.myIp?.ip ?? ''), uuidv5.URL);
                // Now we subscribe to the service version request 
                this.http.get<ServerServiceConfig>(config.serviceUrl + '/version', { params: { theme: config.themeDir } }).subscribe({
                  error: (httpError: { status: number }): ObservableInput<{}> => {
                    this.context.changeMessage('Enable to connect to serivce');
                    console.error('Error getting version information %O', httpError);
                    resolve(false);
                    return this.router.navigateByUrl('/error');
                  },
                  next: (serviceConfig: ServerServiceConfig) => {
                    ServerLoginService.configService = Object.assign({ ...config }, serviceConfig);
                    /*
                      console.log('reset the chat server ' + local.serviceUrl);
      
                      module.SocketIoModule.forRoot({
                        url: ServerLoginService.configService.serviceUrl,
                        options: {}
                      });
                      */
                    this.context.setApplicationInformation(ServerLoginService.configService);
                    resolve(true);
                  }
                });
              }
            });
          }
        });
      });
    };
  }

  /** 
   * This intercepts the request to the server and attempts to add the security token  
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // This adds the current authorization token to the outgoing header
    // Special Case, when delegating, we need to keep the original admin token so we can return after the delegation is completed
    switch (request.url) {
      case '$service/delegate':
        // Store the admin token 
        this.adminToken = this.token;
        break;
    }
    // if (request.method != 'OPTIONS') {
    //   this.context.changeMessage('');
    // }
    const isMutara = request.url.includes('$service');
    request = (ServerLoginService.securityToken)
      ? request.clone({ withCredentials: true, setHeaders: { 'X-Mutara-Security': ServerLoginService.securityToken, 'X-Mutara-Client': ServerLoginService.myIp?.ip } })
      : request.clone({ withCredentials: isMutara });
    // Change the url to point to the logged in service url as the local config should have been set!
    if (isMutara) {
      if (!!ServerLoginService?.configService?.serviceUrl) {
        request = request.clone({ url: request.url.replace('$service', ServerLoginService.configService.serviceUrl) });
      } else {
        return next.handle(request.clone({ url: '/' }));
      }
    }

    // send cloned request with header to the next handler and catch the response
    return next.handle(request).pipe(
      map(
        (resp: any) => {
          return this.handleResponse(resp);
        }),
      catchError((error: HttpErrorResponse) => {
        if (error.status > 399) {
          if (error.status != 401) {
            this.context.changeMessage(`Error: ${error.error}`, 'Acknowledge');
          }
          this.context.setFailedLogin(true);
          console.log("Post %O fail\n%O", request.url, error);
        }
        return throwError(() => error);
      })
    );
  }

  /** Handle the correct response */
  handleResponse(response: HttpResponse<any>): HttpEvent<any> {
    if (response instanceof HttpResponse) {
      if (!!response.body) {
        const body = response.body, keys = Object.keys(body);
        if (keys.length > 0 && ['username', 'lastname', 'defaultLayout'].every((key) => {
          return keys.includes(key);
        })) {
          console.log('Login with response %O', body);
          this.context.setFailedLogin(false);

          //   console.log( 'Should be user info %O', body ); 
          if (body.type !== undefined) {
            this.logoutTime = body.logoutTime;
            this.context.setLoginData(
              {
                username: body.username || body.email,
                nickname: body.nickname,
                phone: body.cellphone,
                firstname: body.firstname,
                lastname: body.lastname,
                email: body.email || body.username,
                lastCluster: body.lastCluster,
                defaultLayout: body?.defaultLayout,
                //  editor: true,
              });
          }
          response = response.clone({ body: body });
          this.context.changeMessage('');
        }

        // Static timer, only one per browser
        if (!!this.logoutTime) {
          if (ServerLoginService.logoutTimer != -1) {
            clearTimeout(ServerLoginService.logoutTimer);
            ServerLoginService.logoutTimer = -1;
          }

          ServerLoginService.logoutTimer = setTimeout(() => {
            this.context.nextMessage("logout", true);
          }, this.logoutTime);
        }
      }
    }
    return response;
  }

}
